import Vue from 'vue'

export default ({ bus, account, carrier, api, models }) => {
  return new Vue({
    data () {
      return {
        reports: carrier.collection({
          missing: {}
        }),
        urlMonitors: {
          all: []
        },
      }
    },
    methods: {
      async fetch () {
        const response = await api.get('url-monitors', { with_compressed_attributes: true })
        this.$set(this.urlMonitors, 'all', response.data.map(monitor => {
          return {
            id: monitor.i,
            url: monitor.u,
            domain: monitor.d,
          }
        }))
      }
    },
    created () {
      bus.on('url-monitoring/require_refresh', this.fetch)

      if(account.isVerified) {
        this.fetch()
        this.reports.sync({
          all: models.CarrierObjects.urlMonitorReport()
        })
      } else {
        this.$set(this.urlMonitors, 'all', [])
        this.reports.purge()
      }
    },
    destroyed () {
      bus.off('url-monitoring/require_refresh', this.fetch)
    }
  })
}